import styled from "@emotion/styled";
import { Dialog, DialogContent } from "@mui/material";

export const UploadDialog = styled(Dialog)`
    > div > .MuiBackdrop-root {
        background: rgba(0, 0, 0, 0.55);
        transition: opacity 160ms ease;
    }

    > div > .MuiPaper-root {
        margin: 32px;
        width: 100%;
        max-width: 55vw;

        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            margin: 0;
            width: 100%;
            max-width: 100%;
            height: 100%;
            max-height: 100%;
            border-radius: 0;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            position: fixed;
        }
    }
`;

export const UploadDialogContent = styled(DialogContent)`
    background-color: ${({ theme }) => theme.palette.primary.dark2};
    position: relative;
    padding: 0;
    display: flex;
    flex-direction: column;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 100%;
    }
`;

export const UploadDialogHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 12px;
    flex: 0 0 70px;
`;

export const UploadDialogBody = styled.div`
    padding: 20px 24px;
    flex: 1 1 auto;
    overflow: auto;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 16px;
    }
`;

export const UploadDialogCloseButton = styled.button`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.72);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    line-height: 1;

    &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.92);
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 44px;
        height: 44px;
        font-size: 32px;
        border-radius: 12px;
    }
`;
